import { z } from 'zod/v3';

export const profileSchema = z.object({
  id: z.string().uuid(),
  role: z.enum(['customer', 'admin', 'memecoins', 'super-admin']),
  plan: z.enum(['founder']).nullable(),
  name: z.string(),
  displayName: z.string().nullable(),
  email: z.string().email(),
  emailIsVerified: z.boolean(),
  avatarUrl: z.string().nullable(),
  bio: z.string().nullable(),
  emailPreferences: z.array(z.enum(['security', 'marketing'])),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date().nullable(),
  deletedAt: z.coerce.date().nullable()
});

export type Profile = z.infer<typeof profileSchema>;

export type ApiResponse<T = unknown> =
  | { success: true; data: T; message: string }
  | { success: false; data: null; message: string };
